export default __webpack_public_path__ + "e227874d37941cbc6708271fcb1ce744.png";